import Base from './base';


class Files extends Base {

    uploadFile(data: any){
        return this.upload('case/attach-file', data, false)
    }

    deleteFile(data:any){
        return this.delete('case/delete-file', {data})
    }

}

export default new Files();
